import { Fragment, useEffect, useState } from "react";
import { get, post } from "../../api";
import companyDefault from "../../images/resource/company-logo/1-1.png";
import JobListItem from "../Protected/Common/JobListItem";

const Recentjobs = ({ isLogin }) => {
  const [recentJobs, setRecentJobs] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [searchData, setSearchData] = useState({
    category: "",
    job_title: "",
    postcode: "",
  });
  const [searchList, setSearchList] = useState([]);

  useEffect(() => {
    if (isLogin) {
      getActiveJobs();
    } else {
      setSearchList([]);
      setLoading(false);
    }
  }, [isLogin]);
  const getActiveJobs = async () => {
    const url = "/job/jobs/search";
    setLoading(true);
    try {
      const response = await post(url, {
        ...searchData,
        // page: page,
      });
      console.log("search", response);
      console.log(response);
      if (response?.status === 200) {
        setSearchList(response?.data);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <>
      {/* <!-- Job Section --> */}
      <section className="job-section style-two">
        <div className="auto-container wow fadeInUp">
          <div className="sec-title text-center">
            <h2>Recent Jobs</h2>
            <div className="text">
              Know your worth and find the job that qualify your life
            </div>
          </div>

          {isLogin ? (
            <div className="row wow fadeInUp animated animated">
              {searchList?.map((job) => {
                return (
                  <Fragment key={job?.jobId}>
                    <JobListItem
                      job={job}
                      isLogin={isLogin}
                      classStyle={"job-block col-lg-4 col-md-4 col-sm-4"}
                    />
                  </Fragment>
                );
              })}
            </div>
          ) : (
            <div className="text-center" style={{ padding: "24px 0" }}>
              <p style={{ marginBottom: 16 }}>
                Please log in or register to view recent jobs.
              </p>
              <div className="btn-box" style={{ gap: 12 }}>
                <a href="/#/login" className="theme-btn btn-style-one bg-blue" style={{ marginRight: 12 }}>
                  <span className="btn-title">Log In</span>
                </a>
                <a href="/#/register" className="theme-btn btn-style-three">
                  <span className="btn-title">Register</span>
                </a>
              </div>
            </div>
          )}
        </div>
      </section>
      {/* <!-- End Job Section --> */}
    </>
  );
};
export default Recentjobs;
